// Display alias map for device SNs / names.
// Keeps underlying SN for MQTT/DB, only changes UI label.
export const DEVICE_DISPLAY_NAMES: Record<string, string> = {
  prise_telerupteur_2: 'WattelEM',
  'Auto-Device-ZCE-GO-3479e78c9009430db9': 'WattelGo',
  'Auto-Device-ZCE-WL-6bf0da86638e485bbf': 'WattelWall',
};

export function displaySn(sn: string | null | undefined): string {
  if (!sn) return '—';
  return DEVICE_DISPLAY_NAMES[sn] || sn;
}
